module.exports = __webpack_public_path__ + "img/鼎锐联能耗分析软件.c5a29866.png";